<template>
  <footer class="footer">
    <div class="wrap footer-inner">
      <p>Copyright © 2023-{{ currentYear }} 贵州微米数字信息科技有限公司 · 版权所有</p>
      <p class="beian-row">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">备案号: 黔ICP备2023008694号</a>
        <img src="@/assets/beian.png" alt="公安备案" class="beian-icon">
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=52010302003768" target="_blank" rel="noreferrer">贵公网安备52010302003768号</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.footer {
  border-top: 1px solid var(--line);
  padding: 36px 0 44px;
}

.footer-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 6px;
  font-family: var(--mono);
  font-size: 12px;
  color: var(--ink-3);
  line-height: 2;
}

.footer-inner a {
  color: var(--ink-2);
  text-decoration: none;
}

.beian-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.beian-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin: 0 4px 0 10px;
}
</style>
